import { render, staticRenderFns } from "./ReserveStage1.vue?vue&type=template&id=21163793&scoped=true&"
import script from "./ReserveStage1.vue?vue&type=script&lang=js&"
export * from "./ReserveStage1.vue?vue&type=script&lang=js&"
import style0 from "./ReserveStage1.vue?vue&type=style&index=0&id=21163793&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21163793",
  null
  
)

export default component.exports